import React, { Component } from 'react';
import Tile from '../components/tile';
import Video from '../components/video';
class ShawPen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playVideo: false,
    
      videoUrl: '',
      images: [
        {
          url:  'man.jpg',
          video: 'ruling-machine',
          subtitles: undefined,
          subtitlesIrish: undefined,
          prevText: "",
          nextText: "Next Printer"
        },
         {
          url:  'man.jpg',
          subtitles: 'captions_Shaw Pen.vtt',
          subtitlesIrish: 'captions_Irish_Shaw.vtt',
          video: 'donKerrigan',
          prevText: "Previous Printer",
          nextText: ""
        },
       
      ],
      mediaIndex: 0
    };
  }
  
  playVideo(index) {
    this.setState({ playVideo: true, mediaIndex: index });

    var elem = document.body;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
      document.body.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
      elem.msRequestFullscreen();
    }
  }

  closeVideo() {
    this.setState({ playVideo: false, mediaIndex: 0 });

  }

  nextVideo() {
   if( this.state.mediaIndex < this.state.images.length -1 ){
    this.setState({mediaIndex: this.state.mediaIndex + 1})
   }
    else{
      this.setState({ playVideo: false, mediaIndex: 0 });
    }
  }

  prevVideo() {
    if( this.state.mediaIndex > 0 )
    this.setState({mediaIndex: this.state.mediaIndex - 1})
  }
  render() {
    const mediaIndex = this.state.mediaIndex;
    const text =
    'The Ruling Machine was used to produce three-colour rulings on paper for ledgers, copybooks and notebooks.';
    return (
      <div className="shaw">
        {this.state.playVideo ? (
          <Video
            onClose={() => this.closeVideo()}
            onNext={() => this.nextVideo() }
            playNext={() => this.nextVideo()}
            nextText={this.state.images[mediaIndex].nextText}
            noLast={this.state.mediaIndex === this.state.images.length -1}
            subtitlesIrish={this.state.images[mediaIndex].subtitlesIrish}
            noFirst={this.state.mediaIndex === 0}
            onPrev={() => this.prevVideo()}
            videoUrl={this.state.images[mediaIndex].video}
            subtitles={this.state.images[mediaIndex].subtitles}
            imageUrl={this.state.images[mediaIndex].url}
            nextText={this.state.images[mediaIndex].nextText}
            prevText={this.state.images[mediaIndex].prevText}
          />
        ) : (
          <div style={{flex: 1}}>
            <Tile
              bg={'man.jpg'}
              onPlay={(index) => this.playVideo(index)}
              title={'Shaw'}
              subTitle={
                '— Don Kerrigan'
              }
              bold={'Ruler'}
              text={text}
            />
            </div>
        )}
      </div>
    );
  }
}

export default ShawPen;



// WEBPACK FOOTER //
// ./src/pages/ShawPen.js